import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class StoreService {

  private img: Subject<string> = new Subject<string>();

  constructor() { }

  ////////////////// communicate with collection and get the property og items when drag and drop /////////////
  sendImageProfil(img: string): void {
    this.img.next(img);
  }

  getImageProfil(): Observable<string> {
    return this.img.asObservable();
  }

}
